declare var swal: any;
import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateParserFormatter, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';


import { FieldData } from '../../../../../../models/actor/actor';


@Component({
    selector: 'auto-gen-cvs',
    templateUrl: './autogencvs.component.html',
    styleUrls: ['./autogencvs.component.scss']
})

export class AutoGenCvsComponent implements OnInit {
    @Input() public mode;
    @Input()
    public FormMode: string = 'Edit';
    @Input() public field: FieldData;
    ngOnInit(): void {
       
    }
}
